module.exports = __webpack_public_path__ + "img/loader.83da4048.gif";